import { all } from 'redux-saga/effects'

import { fetchSaga } from './fetch/saga'

export function* exportSaga() {
  yield all([fetchSaga()])
}
